export default __webpack_public_path__ + "static/media/FieldOfTheDead.a61506ec.jpg";